// Includes all the API endpoints.
// For responses that returns an array,
// use /{endpoint}/all
// for responses that returns a single resource,
// use /{endpoint}
export enum APIEndpointEnum {
  GEOBLOCK = "/check-restricted",

  ANALYTICS = "/analytics",
  ACCOUNT = "/account",
  MMP = "/mmp",
  BALANCE_HISTORY = "/balance-history",
  PRICE_HISTORICAL = "/index-history",
  INDEX = "/index",
  TIME = "/time",

  OPTIONS_CHAIN = "/options-chain",
  MARKETS = "/markets",

  ORDERBOOK = "/orderbook",

  ORDERS = "/orders", // Get orders
  OPEN_ORDERS = "/open-orders", // Cursor-paginated open orders (instrument_type + asset filters)
  POSITIONS = "/positions", // Cursor-paginated live positions (instrument_type + asset filters)
  ORDER_HISTORY = "/order-history", // Get orders

  TRADES = "/trade-history", // Trade history
  POSITION_HISTORY = "/position-history", // Position history (settled positions)
  INSTRUMENT_TRADES = "/instrument-trades",
  OPTIONS_HISTORY = "/options-history", // Options history

  TRANSACTION_HISTORY = "/transaction-history",

  PORTFOLIO = "/portfolio",
  PORTFOLIO_MARGIN = "/account/portfolio-margin",
  STATISTICS = "/statistics",
  MARKET_SUMMARY = "/market-summary",
  INSTRUMENT = "/instrument",
  MARGIN = "/margin",
  NOTIFICATIONS = "/notifications",

  // QRE multi-asset risk (Quantum Risk Engine). Path is `/risk/multi-asset/:user`,
  // but the suffix is appended at the call site (see useMultiAssetRisk).
  RISK_MULTI_ASSET = "/risk/multi-asset",

  // Off-chain TP/SL trigger executor, proxied verbatim by the backend.
  // `/tpsl/nonce/:trader` and `/tpsl/orders/:id` append their suffix at the
  // call site (see src/hooks/tpsl/tpsl.client.ts).
  TPSL_ORDERS = "/tpsl/orders",
  TPSL_NONCE = "/tpsl/nonce",

  FUNDING = "/funding",
  FUNDING_HISTORY = "/funding-history",
  SETTLEMENT_HISTORY = "/settlement-history",

  LEADERBOARD = "/leaderboard",

  REFERRAL_HISTORY = "/referral-history",
  REFERRAL_REWARD_HISTORY = "/referral-reward-history",
  REFERRAL_STATISTICS = "/referral-statistics",
  REFERRAL_CODES = "/referral-codes",
  CHECK_REFERRAL = "/check-referral",
  INVITE_STATUS = "/invite/status",
  INVITE_REDEEM = "/invite/redeem",
  INVITE_CLAIM = "/invite/claim",
  CLAIM_REWARDS = "/claim-referral-rewards",
  EMAIL_PREFERENCES = "/account/email-preferences",
  EMAIL_PREFERENCE = "/account/email-preference",
  EMAIL_VERIFIED = "/account/email-verified",
  EMAIL_ADDRESS = "/account/email-address",

  RFQS = "rfqs",
  QUOTES = "quotes",
  ACCUMULATED_FUNDINGS = "/account/accumulated-fundings",

  MAX_LEVERAGES = "/max-leverages",
  ACCOUNT_LEVERAGE = "/account/leverage",
  YIELD_VAULT = "/yield-vault",

  FARM_BOOST = "/farm-boost",
}

export enum PageEndpointEnum {
  TRADING = "/",
  REF_LINK = "/r", // A redirect page for when a user lands on the app via a reflink
  PORTFOLIO = "/portfolio",
  REFERRALS = "/referrals",
  MARGINX = "/perps",
  ACCOUNT = "/account",
  HISTORICAL = "/historical",
  SETTINGS = "/settings",
  SETTLEMENT_HISTORY = "/settlement-history",
  STRATEGIES = "/strategies",
  RFQ = "/rfq",
  PWA = "/pwa",
  FAUCET = "/faucet",
  WATCHLIST = "/watchlist",
  LEADERBOARD="/leaderboard",
  STATS = "/stats",
  SHORTCUTS = "/shortcuts"
}
